"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Divider = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _coreMixins = require("@vfuk/core-mixins");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var Divider = _styledComponents["default"].hr.withConfig({
  displayName: "Dividerstyle__Divider",
  componentId: "sc-petl9d-0"
})(function (props) {
  var isHorizontal = props.orientation === 'horizontal';
  var borderColor = props.inverse ? props.dividerTheme.appearance[props.appearance].inverse.color : props.dividerTheme.appearance[props.appearance].color;
  var variableMargin = props.noMargin ? 0 : 2;
  var dividerStyle = "".concat(props.theme.border.width[1], " ").concat(props.dividerTheme.level[props.level].borderStyle, " ").concat(borderColor);
  return (0, _styledComponents.css)(["width:", ";height:", ";", " ", " padding:0;border:0;", ":", ";"], isHorizontal ? '100%' : 0, isHorizontal ? 0 : '100%', isHorizontal && (0, _styledComponents.css)(["", ""], (0, _coreMixins.advancedSpacing)('margin', [variableMargin, 0])), !isHorizontal && (0, _styledComponents.css)(["", ""], (0, _coreMixins.advancedSpacing)('margin', [0, variableMargin])), isHorizontal ? 'border-top' : 'border-left', dividerStyle);
});
exports.Divider = Divider;